import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_remove_1_week_from_plans~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_remove_1_week_from_plans'),
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_remove_1_week_from_plans~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_remove_1_week_from_plans'),
			},
		},
		'activity-female-tai-chi-walking-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-pr&exp=web_remove_1_week_from_plans~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_remove_1_week_from_plans'),
			},
		},
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_remove_1_week_from_plans~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_remove_1_week_from_plans'),
			},
		},
	},
]

export default config
